<!--
 * @Date: 2022-09-28 17:36:33
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-13 12:43:28
 * @description: description
-->
<template>
  <div :class="$style.honor">
    <div :class="$style.title">{{ info.title }}</div>
    <div
      :class="$style.authenticationItem"
      v-for="(item, index) in info.authentication"
      :key="index"
    >
      <img :class="$style.itemImg" :src="item.cover" alt="" />
      <div :class="$style.itemContent">{{ item.content }}</div>
    </div>
    <div :class="$style.infoContent">
      <div
        :class="$style.itemBox"
        v-for="(item, index) in info.mobileContent"
        :key="index"
      >
        <div :class="$style.itemTitle">{{ item.title }}</div>
        <div
          :class="$style.infoBox"
          v-for="(info, index) in item.content"
          :key="index"
        >
          {{ info }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: '',
  props: {
    info: Object
  }
}
</script>

<style lang="scss" module>
.honor {
  box-sizing: border-box;
  position: relative;
  padding: 50px 20px;
  background: linear-gradient(3deg, #fff9f0 0%, #fff8ec 100%);

  .title {
    height: 28px;
    margin-bottom: 25px;
    text-align: center;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #404040;
  }

  .authenticationItem {
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    // width: 335px;
    height: 116px;
    padding: 24px 20px 27px;
    margin: 0 auto 16px;
    background: linear-gradient(163deg, #fff5e7 0%, #ffffff 100%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset 2px 2px 0px 0px #ffffff;
    border-radius: 6px;
  }

  .itemImg {
    display: block;
    width: 68px;
    height: 68px;
    margin-right: 20px;
  }

  .itemContent {
    line-height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #404040;
  }

  .infoContent {
    box-sizing: border-box;
    // height: 982px;
    padding: 0 16px 30px;
    background: linear-gradient(163deg, #fff5e7 0%, #ffffff 100%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset 2px 2px 0px 0px #ffffff;
    border-radius: 6px;
  }

  .itemBox {
    position: relative;
    text-align: center;
  }

  .itemTitle {
    position: relative;
    display: inline-block;
    height: 28px;
    margin-top: 30px;
    margin-bottom: 19px;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #e7b15f;

    &::before,
    &::after {
      content: "";
      position: absolute;
      right: 0;
      width: 14px;
      height: 26px;
      background-size: 100%;
    }

    &::before {
      top: 0;
      left: -23px;
      background-image: url("../../../assets/img/aboutus/pc/honor/honor-title-left.png");
    }

    &::after {
      right: -23px;
      top: 0;
      background-image: url("../../../assets/img/aboutus/pc/honor/honor-title-right.png");
    }
  }

  .infoBox {
    box-sizing: border-box;
    position: relative;

    padding-left: 10px;
    margin-bottom: 12px;
    text-align: left;
    line-height: 20px;
    font-size: 14px;
    font-weight: 300;
    color: #404040;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 8px;
      width: 4px;
      height: 4px;
      background: #b2b2b2;
      border-radius: 50%;
    }
  }
}
</style>
